// Fonte única dos números do Google (nota e total de avaliações).
// Para atualizar o site, basta alterar os valores abaixo.
// Exemplo: subiu de 181 para 187 avaliações -> mude GOOGLE_REVIEW_COUNT para 187
// e GOOGLE_REVIEW_COUNT_LABEL para "187".

export const GOOGLE_RATING_VALUE = 4.9;

export const GOOGLE_RATING_LABEL = "4,9";

export const GOOGLE_REVIEW_COUNT = 181;

export const GOOGLE_REVIEW_COUNT_LABEL = "181";

export const GOOGLE_STARS = 5;

export const GOOGLE_REVIEW_COUNT_TEXT = `${GOOGLE_REVIEW_COUNT_LABEL} avaliações no Google`;

export const GOOGLE_RATING_SHORT_TEXT = `${GOOGLE_RATING_LABEL} de 5 estrelas`;